import { connect } from "react-redux";
import { cloneDeep } from "lodash";

import Select from "react-select";

import { PlusCircleIcon, MinusCircleIcon } from "@heroicons/react/20/solid";

import { Actions as ACCOUNTINGACTIONS } from "../../../store/actions/accountingActions";


const JournalConditionsWhen = ({
	updateField,
	addPart,
	removePart,
	whenData,
	isOptions,
	partIndex,
	lastPart,
	whenOptions
}) => {
	return (
		<div className={`col-xs-12 ${partIndex ? 'p-0 pt-5' : 'p-0'}`}>
			<div className="col-xs-1 p-0">
				{partIndex > 0 ? (
					<label className={"pull-right"}>And</label>
				): <label className={"pull-right"}>When</label>}
			</div>
			<div className="col-xs-5">
				<Select
					name="when"
					options={whenOptions}
					placeholder="Choose One"
					value={whenOptions?.find((i) => i.value == whenData.when)}
					onChange={(e) => {
						updateField("when", e?.value);
					}}
				/>
			</div>
			<div className="col-xs-5">
				<label style={{
					position:"absolute",
					marginLeft: -20,
				}}>Is</label>
				<Select
					name="Is"
					isClearable={true}
					isMulti={true}
					options={isOptions}
					placeholder="Choose One"
					value={isOptions?.filter((i) => whenData?.is?.includes(i.value))}
					onChange={(e) => {
						updateField("is", e.map(r => r.value) || null);
					}}
				/>
			</div>
			<div className="col-xs-1"
				 style={{
					display: "flex",
					padding: 0,
					// justifyContent: "space-between",
					justifyContent: "flex-end",
					 marginTop: '0.5em'
				 }}
			>

				{/*<MinusCircleIcon
						onClick={() => removePart()}
						className={"text-white"}
						style={{ height: "2.5rem", float: "left", fill:"#e83e36", cursor: "pointer"}}
					/>*/}
				<button
					className="btn btn-danger pull-left"
					style={{ padding: 3 }}
					type="button"
					onClick={() => removePart()}
				>
					<MinusCircleIcon style={{ height: "1.3em", float: "left" }} />
				</button>
				{ lastPart && (

						/*<PlusCircleIcon
							onClick={() => addPart()}
							className={"text-white"}
							style={{ height: "2.5rem", float: "left", fill:"#00bb87", cursor: "pointer"}}
						/>*/
					<button
						className="btn btn-success pull-left"
						style={{ padding: 3 }}
						type="button"
						onClick={() => addPart()}
					>
						<PlusCircleIcon
							style={{ height: "1.3em", float: "left"}}
						/>
					</button>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state,ownProps) => {

	const row = ownProps.rowIndex;
	const part = ownProps.partIndex;
	const data = state?.accounting?.journals?.conditions || [];
	const whenParts = data?.[row]?.when || [];
	const whenData = whenParts?.[part] || [];


	// TODO EE + DEPT options should be saved in redux to reduce the number of times we calculate this
	const employees = state?.employees?.employeeListWithSalary || [];

	// map the employees to the format that the Select component expects
		// include the reference number in the label or idNo / NIC number
	const employeeOptions =
		employees?.map((employee) => (
			{
				label: `${employee?.employeeName} ${employee?.employeeSurname} (${employee?.reference ?? employee?.idNo ?? employee?.NIC})`,
				value: employee.id
			}
		));

	const departments = state?.company?.settings?.departments || [];

	const departmentOptions = departments.map((department) => ({ label: department?.name, value: department.id }));

	const uniqueRoles = [...new Set(employees.map(e => e?.roleName))];
	const roleOptions = uniqueRoles.map((role) => ({ label: role, value: role }));

	const whenOptions = [
		{
			label: "Employee",
			value: "Employee",
		},
		{
			label: "Department",
			value: "Department",
		},
		{
			label: "Role",
			value: "Role",
		},
		{
			label: "Pay Item",
			value: "Pay Item",
		},
	];

	let isOptions = []

	// pay items are company allowances and deductions
	const payItems = state?.company?.settings?.allowances || [];
	const payItemOptions = payItems.map((payItem) => ({ label: payItem?.name, value: payItem.id }));


	console.log('whenData.when',whenData,state?.accounting?.journals?.conditions)
	switch (whenData.when) {
		case "Employee":
			isOptions = employeeOptions;
			break;
		case "Department":
			isOptions = departmentOptions;
			break;
		case "Role":
			isOptions = roleOptions;
			break;
		case "Pay Item":
			isOptions = payItemOptions;
			break;

		// case "Role": return employeeOptions;
	}

	return {
		whenData,
		isOptions,
		// return only options that are not used in other parts
		whenOptions: whenOptions.filter((i) => !whenParts.map((p,index) => index != part && p.when).includes(i.value)),
	}

};

const mapDispatchToProps = (dispatch,ownProps) => ({
	updateField: (field, value) => dispatch(ACCOUNTINGACTIONS.updateJournalCondition({field, value, type: "when", row: ownProps.rowIndex, part: ownProps.partIndex})),
	addPart: () => dispatch(ACCOUNTINGACTIONS.updateJournalCondition({ type: "when", row: ownProps.rowIndex, part: ownProps.partIndex + 1})),
	removePart: () => dispatch(ACCOUNTINGACTIONS.updateJournalCondition({ type: "when", row: ownProps.rowIndex, part: ownProps.partIndex, action: "remove"})),
});

export default connect(mapStateToProps, mapDispatchToProps)(JournalConditionsWhen);
